((w, d) => {
    function refreshText(dropdown, button) {
        const countspan = dropdown.querySelector('.Dropdown__count');
        const activesspan = dropdown.querySelector('.Dropdown__actives');
        const actives = dropdown.querySelectorAll('.FormCheckbox:checked');
        const count = actives.length;
        let counttext = '';
        let activetext = '';
        actives.forEach((active, index) => {
            const string = active.parentElement.querySelector('label').textContent;
            if (index !== 0) {
                activetext = `${activetext}, ${string}`;
            } else {
                activetext = `: ${string}`;
            }
        });
        if (count === 0) {
            counttext = button.getAttribute('data-empty');
        } else {
            counttext = `${count} ${button.getAttribute('data-text')}`;
        }
        countspan.innerHTML = counttext;
        activesspan.innerHTML = activetext;
    }

    function openDropdown(button) {
        button.setAttribute('aria-expanded', 'true');
    }

    function closeDropdown(dropdown, button) {
        button.setAttribute('aria-expanded', 'false');
        refreshText(dropdown, button);
    }

    const dropdowns = d.querySelectorAll('.Dropdown');

    dropdowns.forEach((dropdown) => {
        const button = dropdown.querySelector('.Dropdown__button');
        const all = dropdown.querySelectorAll('a, input, button');
        const last = all[all.length - 1];
        if (!button) {
            return;
        }

        closeDropdown(dropdown, button);

        button.addEventListener('click', () => {
            const exp = button.getAttribute('aria-expanded');
            if (exp === 'true') {
                closeDropdown(dropdown, button);
            } else {
                openDropdown(button);
            }
        });

        d.addEventListener('click', (e) => {
            if (!dropdown.contains(e.target)) {
                closeDropdown(dropdown, button);
            }
        });

        dropdown.addEventListener('keydown', (e) => {
            if (e.key === 'Escape') {
                closeDropdown(dropdown, button);
                button.focus();
            }
        });

        button.addEventListener('keydown', (e) => {
            if (e.key === 'Tab' && e.shiftKey) {
                closeDropdown(dropdown, button);
            }
        });

        last.addEventListener('keydown', (e) => {
            if (e.key === 'Tab' && !e.shiftKey) {
                closeDropdown(dropdown, button);
            }
        });
    });
})(window, document);
